import { render, staticRenderFns } from "./VideoPromo.vue?vue&type=template&id=252229df&scoped=true"
import script from "./VideoPromo.vue?vue&type=script&lang=js"
export * from "./VideoPromo.vue?vue&type=script&lang=js"
import style0 from "./VideoPromo.vue?vue&type=style&index=0&id=252229df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252229df",
  null
  
)

export default component.exports